// Thin wrapper around gtag.js loaded in public/index.html.
// No-ops when gtag is unavailable (dev without network, ad blockers).
export const GA_MEASUREMENT_ID = "G-CQXLPEW4E6";

function gtag(...args) {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag(...args);
  }
}

export function trackPageView(path) {
  gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackFormSubmit(formName, params = {}) {
  gtag("event", "form_submit", { form_name: formName, ...params });
}

// GA4 already geolocates every hit from IP (country/region/city reports).
// This adds the site's own USA/Global edition as a user property for segmentation.
export function setSiteRegion(region) {
  gtag("set", "user_properties", { site_region: region });
}
